<table>
  <caption>
    {{
      'catalog.volumeDiscountTable_heading' | cxTranslate
    }}
  </caption>
  <thead>
    <tr>
      <th class="col-quantity" scope="col">{{ 'catalog.volumeDiscountTableQuantity_heading' | cxTranslate }}</th>
      <th class="col-discount" scope="col">{{ 'catalog.volumeDiscountTableVolumeDiscount_heading' | cxTranslate }}</th>
      <th class="col-price" scope="col">{{ 'catalog.volumeDiscountTableNewUnitPrice_heading' | cxTranslate }}</th>
    </tr>
  </thead>
  <tbody>
    @for (scalePrice of volumeDiscount?.scalePrices ?? []; track scalePrice.scaleQuantity) {
      <tr>
        @if (scalePrice.active) {
          <td>
            <div class="d-flex gap-2">
              <span nz-icon class="py-color-success-500" nzType="check-circle" nzTheme="fill"></span>
              <div>
                <p>
                  <strong>
                    @if (scalePrice.scaleQuantity === 0) {
                      -
                    } @else {
                      {{ scalePrice.scaleQuantity | cxNumeric }}
                      {{ volumeDiscount.scaleUnit | unit: scalePrice.scaleQuantity }}
                    }
                  </strong>
                </p>
                <p *ngIf="scalePrice.scaleDiscountPercent > 0">
                  <small>
                    {{ 'catalog.volumeDiscountActiveDescription_heading' | cxTranslate }}
                  </small>
                </p>
              </div>
            </div>
          </td>
          <td>
            <p>
              <strong>{{
                scalePrice.scaleDiscountPercent === 0 ? '-' : (scalePrice.scaleDiscountPercent | cxNumeric) + '%'
              }}</strong>
            </p>
            <p *ngIf="scalePrice.scaleDiscountPercent > 0">
              <small>
                {{
                  'catalog.comparativePrice_heading'
                    | cxTranslate
                      : {
                          count: volumeDiscount.scalePriceQuantity,
                          price: formatNegativePrice(scalePrice.scaleDiscountFormatted),
                          unit: volumeDiscount.scalePriceUnit | unit: volumeDiscount.scalePriceQuantity,
                        }
                }}
              </small>
            </p>
          </td>
          <td>
            <p>
              <strong>{{
                'catalog.comparativePrice_heading'
                  | cxTranslate
                    : {
                        count: volumeDiscount.scalePriceQuantity,
                        price: scalePrice.scalePriceFormatted,
                        unit: volumeDiscount.scalePriceUnit | unit: volumeDiscount.scalePriceQuantity,
                      }
              }}</strong>
            </p>
            <p *ngIf="scalePrice.active && scalePrice.scaleDiscountPercent > 0">
              <small>
                {{
                  'catalog.volumeDiscountTotalDiscount_hint'
                    | cxTranslate
                      : {
                          discount:
                            {
                              value:
                                -(quantity * unit.inEcommerceUnit * scalePrice.scaleDiscount) /
                                (volumeDiscount.scalePriceQuantity * volumeDiscount.scalePriceUnit.inEcommerceUnit),
                            } | price: 'symbol-narrow' : true,
                        }
                }}
              </small>
            </p>
          </td>
        } @else {
          <td>
            @if (scalePrice.scaleQuantity === 0) {
              -
            } @else {
              {{ scalePrice.scaleQuantity | cxNumeric }} {{ volumeDiscount.scaleUnit | unit: scalePrice.scaleQuantity }}
            }
          </td>
          <td>{{ scalePrice.scaleDiscountPercent === 0 ? '-' : (scalePrice.scaleDiscountPercent | cxNumeric) + '%' }}</td>
          <td>
            {{
              'catalog.comparativePrice_heading'
                | cxTranslate
                  : {
                      count: volumeDiscount.scalePriceQuantity,
                      price: scalePrice.scalePriceFormatted,
                      unit: volumeDiscount.scalePriceUnit | unit: volumeDiscount.scalePriceQuantity,
                    }
            }}
          </td>
        }
      </tr>
    }
  </tbody>
</table>
